/*
 * Prime Collections — comportamiento de la página (sin dependencias).
 *
 * - Combo: el cliente elige 1, 2 o 3 modelos; todos los botones de WhatsApp,
 *   precios y la barra fija del celular se actualizan con lo que eligió.
 * - Galería de fotos, carrusel de clientes (videos) y barra fija móvil.
 * - Pixel de Meta opcional (evento "Contact" al tocar WhatsApp).
 *
 * Los datos (número, precios, nombres) vienen de <script id="prime-config">,
 * que se llena desde Personalizar > Configuración del tema.
 */
(function () {
  'use strict';

  var cfg;
  try {
    cfg = JSON.parse(document.getElementById('prime-config').textContent);
  } catch (e) {
    return;
  }

  var models = cfg.models;
  var tiers = cfg.tiers;
  var MAX_UNITS = tiers[tiers.length - 1].units;
  var BASE_PRICE = tiers[0].unitPrice;
  var wa = String(cfg.whatsapp || '').replace(/\D/g, '');

  // Modelo elegido en cada unidad del combo, en orden.
  var slots = [models[0].id];

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function modelName(id) {
    for (var i = 0; i < models.length; i++) if (models[i].id === id) return models[i].name;
    return id;
  }
  function formatPEN(n) {
    var hasDecimals = Math.round(n * 100) % 100 !== 0;
    return 'S/' + (hasDecimals ? n.toFixed(2) : Math.round(n));
  }
  function pricing(units) {
    var u = Math.min(Math.max(Math.round(units), 1), MAX_UNITS);
    var tier = tiers[0];
    for (var i = 0; i < tiers.length; i++) if (tiers[i].units === u) tier = tiers[i];
    return { units: u, unitPrice: tier.unitPrice, total: tier.unitPrice * u, savings: (BASE_PRICE - tier.unitPrice) * u };
  }
  function unitsLabel(n) {
    return n + (n === 1 ? ' modelo' : ' modelos');
  }
  function quantities() {
    var q = {};
    models.forEach(function (m) {
      q[m.id] = 0;
    });
    slots.forEach(function (id) {
      q[id] += 1;
    });
    return q;
  }

  /** Mensaje prellenado; deja "Mi ciudad" abierto a propósito. */
  function whatsappUrl() {
    var q = quantities();
    var lines = models
      .filter(function (m) {
        return q[m.id] > 0;
      })
      .map(function (m) {
        return '- ' + q[m.id] + ' x ' + m.name;
      })
      .join('\n');
    var intro = cfg.soldOut
      ? 'Hola Prime Collections, quiero consultar la disponibilidad de:'
      : 'Hola Prime Collections, quiero pedir:';
    var text = intro + '\n' + lines + '\n\n¿Hacen envío a mi ciudad?\nMi ciudad es: ';
    return 'https://wa.me/' + wa + '?text=' + encodeURIComponent(text);
  }

  /* ---------- Estado del combo ---------- */

  function setUnits(target) {
    var goal = Math.min(Math.max(target, 1), MAX_UNITS);
    var next = slots.slice(0, goal);
    while (next.length < goal) {
      // Sugiere primero un modelo que aún no esté en el combo.
      var pick = models.filter(function (m) {
        return next.indexOf(m.id) === -1;
      })[0];
      next.push((pick || models[0]).id);
    }
    slots = next;
    render();
  }
  function setSlot(index, id) {
    slots = slots.map(function (cur, i) {
      return i === index ? id : cur;
    });
    render();
  }
  function addModel(id) {
    if (slots.indexOf(id) === -1) {
      // Al tope, reemplaza la última unidad por el modelo elegido.
      slots = slots.length >= MAX_UNITS ? slots.slice(0, -1).concat(id) : slots.concat(id);
    }
    render();
  }
  function scrollToBuy() {
    var el = document.getElementById('comprar');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- Pintar ---------- */

  function setThumb(row, id) {
    var wrap = qs('[data-pc-slot-thumb]', row);
    var tpl = qs('[data-pc-thumb-template="' + id + '"]');
    if (!wrap) return;
    wrap.textContent = '';
    if (tpl) wrap.appendChild(tpl.content.cloneNode(true));
    row.setAttribute('data-model', id);
  }

  function buildRow(index, id) {
    var tpl = qs('[data-pc-slot-template]');
    var row = tpl.content.firstElementChild.cloneNode(true);
    row.setAttribute('data-pc-slot-row', '');
    row.setAttribute('data-index', String(index));
    qs('[data-pc-slot-num]', row).textContent = '#' + (index + 1);
    var sel = qs('[data-pc-slot-select]', row);
    sel.setAttribute('aria-label', 'Modelo de la unidad ' + (index + 1));
    sel.value = id;
    setThumb(row, id);
    return row;
  }

  function syncSlots(container) {
    var rows = qsa('[data-pc-slot-row]', container);
    if (rows.length !== slots.length) {
      container.textContent = '';
      slots.forEach(function (id, i) {
        container.appendChild(buildRow(i, id));
      });
      return;
    }
    rows.forEach(function (row, i) {
      var sel = qs('[data-pc-slot-select]', row);
      if (sel.value !== slots[i]) sel.value = slots[i];
      if (row.getAttribute('data-model') !== slots[i]) setThumb(row, slots[i]);
    });
  }

  function render() {
    var units = slots.length;
    var price = pricing(units);
    var q = quantities();

    qsa('[data-pc-whatsapp]').forEach(function (a) {
      a.href = whatsappUrl();
    });
    qsa('[data-pc-units-label]').forEach(function (el) {
      el.textContent = unitsLabel(units);
    });
    qsa('[data-pc-total]').forEach(function (el) {
      el.textContent = formatPEN(price.total);
    });

    // Filas de packs (1, 2 o 3 modelos).
    qsa('[data-pc-tier]').forEach(function (btn) {
      var active = Number(btn.getAttribute('data-pc-tier')) === units;
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
      var card = btn.closest('[data-pc-tier-card]');
      if (card) card.setAttribute('data-active', active ? 'true' : 'false');
    });
    var hasTemplate = !!qs('[data-pc-slot-template]');
    qsa('[data-pc-slots]').forEach(function (box) {
      var active = Number(box.getAttribute('data-pc-slots')) === units;
      box.hidden = !active;
      if (active && hasTemplate) syncSlots(box);
    });

    // Tarjetas de "Arma tu combo".
    qsa('[data-pc-add]').forEach(function (btn) {
      var inCombo = q[btn.getAttribute('data-pc-add')] > 0;
      btn.setAttribute('data-in', inCombo ? 'true' : 'false');
      var on = qs('[data-pc-add-on]', btn);
      var off = qs('[data-pc-add-off]', btn);
      if (on) on.hidden = !inCombo;
      if (off) off.hidden = inCombo;
    });

    // Tabla comparativa.
    qsa('[data-pc-choose]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', Number(btn.getAttribute('data-pc-choose')) === units ? 'true' : 'false');
    });
  }

  /* ---------- Eventos (delegados: sobreviven a las ediciones del editor) ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var el;

    if ((el = t.closest('[data-pc-tier]'))) {
      setUnits(Number(el.getAttribute('data-pc-tier')));
      return;
    }
    if ((el = t.closest('[data-pc-choose]'))) {
      setUnits(Number(el.getAttribute('data-pc-choose')));
      scrollToBuy();
      return;
    }
    if ((el = t.closest('[data-pc-add]'))) {
      addModel(el.getAttribute('data-pc-add'));
      scrollToBuy();
      return;
    }
    if ((el = t.closest('[data-pc-thumb]'))) {
      showPhoto(el);
      return;
    }
    if ((el = t.closest('[data-pc-reel]'))) {
      toggleReel(el);
      return;
    }
    if ((el = t.closest('[data-pc-reels-prev]'))) {
      scrollReels(el, -1);
      return;
    }
    if ((el = t.closest('[data-pc-reels-next]'))) {
      scrollReels(el, 1);
      return;
    }
    if ((el = t.closest('[data-pc-whatsapp]'))) {
      trackWhatsApp(el);
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!(sel instanceof Element) || !sel.matches('[data-pc-slot-select]')) return;
    var row = sel.closest('[data-pc-slot-row]');
    if (!row) return;
    setSlot(Number(row.getAttribute('data-index')), sel.value);
  });

  /* ---------- Galería del producto ---------- */

  function showPhoto(btn) {
    var gallery = btn.closest('[data-pc-gallery]');
    if (!gallery) return;
    var index = btn.getAttribute('data-pc-thumb');
    qsa('[data-pc-main]', gallery).forEach(function (main) {
      main.hidden = main.getAttribute('data-pc-main') !== index;
    });
    qsa('[data-pc-thumb]', gallery).forEach(function (b) {
      b.setAttribute('aria-current', b === btn ? 'true' : 'false');
    });
  }

  /* ---------- Carrusel de clientes (videos) ---------- */

  function toggleReel(btn) {
    var video = qs('video', btn);
    if (!video) return;
    video.playsInline = true;
    if (video.paused) {
      // Solo un video suena a la vez.
      qsa('[data-pc-reel] video').forEach(function (other) {
        if (other !== video) other.pause();
      });
      video.muted = false;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      video.pause();
    }
  }

  function markReel(video, playing) {
    var btn = video.closest('[data-pc-reel]');
    if (!btn) return;
    var overlay = qs('[data-pc-reel-play]', btn);
    if (overlay) overlay.style.opacity = playing ? '0' : '1';
    btn.setAttribute('aria-label', playing ? 'Pausar video' : 'Reproducir video');
  }
  // "play" y "pause" no burbujean: se escuchan en fase de captura.
  document.addEventListener('play', function (e) {
    if (e.target instanceof HTMLVideoElement) markReel(e.target, true);
  }, true);
  document.addEventListener('pause', function (e) {
    if (e.target instanceof HTMLVideoElement) markReel(e.target, false);
  }, true);

  function scrollReels(btn, dir) {
    var section = btn.closest('section');
    var track = section && qs('[data-pc-reels]', section);
    if (track) track.scrollBy({ left: dir * 300, behavior: 'smooth' });
  }

  /* ---------- Barra fija (solo celular) ---------- */

  var observers = [];
  function setupSticky() {
    observers.forEach(function (o) {
      o.disconnect();
    });
    observers = [];

    var bar = qs('[data-pc-sticky]');
    if (!bar) return;

    var hero = document.getElementById('buy-cta');
    var final = document.getElementById('final-cta');
    // Sin botón principal en la página (p. ej. una página legal), la barra no se muestra.
    var heroVisible = true;
    var finalVisible = false;

    function apply() {
      var visible = !!hero && !heroVisible && !finalVisible;
      bar.setAttribute('data-visible', visible ? 'true' : 'false');
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if (hero && 'IntersectionObserver' in window) {
      var a = new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        apply();
      });
      a.observe(hero);
      observers.push(a);
    }
    if (final && 'IntersectionObserver' in window) {
      var b = new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        apply();
      });
      b.observe(final);
      observers.push(b);
    }
    apply();
  }

  /* ---------- Pixel de Meta (opcional) ---------- */

  function loadPixel() {
    var id = String(cfg.pixel || '');
    if (!/^\d+$/.test(id) || window.fbq) return;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  function trackWhatsApp(link) {
    try {
      if (!window.fbq) return;
      var units = slots.length;
      window.fbq('track', 'Contact', {
        content_name: 'WhatsApp',
        content_category: link.getAttribute('data-pc-location') || 'whatsapp',
        num_items: units,
        value: pricing(units).total,
        currency: 'PEN'
      });
    } catch (err) {
      /* la analítica nunca debe romper la compra */
    }
  }

  /* ---------- Arranque ---------- */

  function init() {
    render();
    setupSticky();
    qsa('[data-pc-reel] video').forEach(function (v) {
      v.playsInline = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  loadPixel();

  // Editor de temas de Shopify: al editar una sección se vuelve a pintar.
  document.addEventListener('shopify:section:load', init);
})();
